"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemberType = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const types_1 = require("../types");

const MEMBER_TECH_ACCOUNT_DOMAIN = 'techacct.adobe.com';

class MemberType {
  /**
   * @description Creates a new MemberType for use. The 'type' parameter is required.
   *
   * @param {String} type String of type (can be TYPE1, TYPE2, TYPE2E, TYPE3, or USER_GROUP)
   * @param {String} [id] String ID. This will be used to determine if this is a technical account.
   */
  constructor(type, id) {
    this.type = type;
    this.memberId = id;
  }
  /**
   * @description Method to determine if this MemberType represents a Technical Account or not.
   *
   * @returns {Boolean} true if this MemberType represents a Technical Account, else false
   */


  isTechnicalAccount() {
    return this.memberId ? this.memberId.toLowerCase().endsWith(MEMBER_TECH_ACCOUNT_DOMAIN) : false;
  }
  /**
   * @description Method to determine if this MemberType represents a Type1 account or not.
   *
   * @returns {Boolean} true if this MemberType represents a Type1 account, else false
   */


  isType1() {
    return this.type === types_1.MEMBER_TYPE.TYPE1;
  }
  /**
   * @description Method to determine if this MemberType represents a Type2 account or not.
   *
   * @returns {Boolean} true if this MemberType represents a Type2 account, else false
   */


  isType2() {
    return this.type === types_1.MEMBER_TYPE.TYPE2;
  }
  /**
   * @description Method to determine if this MemberType represents a Type2E account or not.
   *
   * @returns {Boolean} true if this MemberType represents a Type2E account, else false
   */


  isType2E() {
    return this.type === types_1.MEMBER_TYPE.TYPE2E;
  }
  /**
   * @description Method to determine if this MemberType represents a Type3 account or not.
   *
   * @returns {Boolean} true if this MemberType represents a Type3 account, else false
   */


  isType3() {
    return this.type === types_1.MEMBER_TYPE.TYPE3;
  }
  /**
   * @description Method to determine if this MemberType is of any user type
   *     (including technical accounts).
   *
   * @returns {Boolean} true if this MemberType represents any user type, else false
   */


  isUser() {
    return this.isType1() || this.isType2() || this.isType2E() || this.isType3();
  }
  /**
   * @description Method to determine if this MemberType represents a User Group or not.
   *
   * @returns {Boolean} true if this MemberType represents a User Group, else false
   */


  isUserGroup() {
    return this.type === types_1.MEMBER_TYPE.USER_GROUP;
  }

}

exports.MemberType = MemberType;